import { type BiLogger } from '../../../Provider/BiLogger/BiLogger';
import { type GooglePayButtonConfig } from '../types';
import { type AppDispatch } from '../../../../store';
import { onPaymentAuthorized } from '../../../../actions/googlePay/onPaymentAuthorized';
import { type WidgetFedopsLogger } from '../../../Provider/Fedops/FedopsProvider';

type CreateOnPaymentAuthorizedParams = {
  transactionInfo: google.payments.api.TransactionInfo;
  biLogger: BiLogger;
  fedopsLogger: WidgetFedopsLogger;
  dispatch: AppDispatch;
};

type CreateOnPaymentAuthorized = (
  params: CreateOnPaymentAuthorizedParams,
) => (paymentData: google.payments.api.PaymentData) => ReturnType<GooglePayButtonConfig['onPaymentAuthorized']>;

export const createOnPaymentAuthorized: CreateOnPaymentAuthorized =
  ({ transactionInfo, biLogger, fedopsLogger, dispatch }) =>
  (paymentData) => {
    return dispatch(onPaymentAuthorized({ transactionInfo, biLogger, fedopsLogger, paymentData })).unwrap();
  };
